/**
 * @description
 * The 'list' role is used to identify an element that creates a list.
 *
 * @specification
 * Adds role='list'.
 */
export var basicListBehavior = function basicListBehavior(props) {
  return {
    attributes: {
      root: {
        role: 'list'
      }
    }
  };
};
//# sourceMappingURL=basicListBehavior.js.map
